import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface User {
  email: string
  name?: string
  sub: string
}

interface AuthState {
  user: User | null
  isAuthenticated: boolean
  sessionChecked: boolean
  setUser: (user: User | null) => void
  setSessionChecked: (checked: boolean) => void
  signOut: () => void
}

// NOTE: Tokens are stored in HTTP-only cookies (managed by server).
// This store only keeps minimal user info for UI purposes.
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      sessionChecked: false,
      setUser: (user) =>
        set({
          user,
          isAuthenticated: !!user,
        }),
      setSessionChecked: (checked) =>
        set({ sessionChecked: checked }),
      signOut: () =>
        set({
          user: null,
          isAuthenticated: false,
        }),
    }),
    {
      name: 'auth-storage',
    }
  )
)
